<app-navigation-header title="Inventory Report" i18n-title="@@inventoryReport-inventoryReportTitle">
	<app-data-set
		#dataSet
		[dataSource]="dataSource"
		defaultPresentationMode="table"
		[appBreadcrumbLabel]="breadcrumbLabel"
		[rowId]="rowId"
		firstColumnProperty="deviceSerialNumber"
	>
		<app-data-set-toolbar>
			<div class="flex-space-around">
				<div *appActionGroup style="width: 100%; display: flex; flex-direction: column">
					<app-data-set-action-button
						style="flex: 1"
						label="Refine Filters"
						i18n-label="@@inventoryReport-refineFilters"
						svgIcon="sl-filter"
						data-automation-id="inventory-report-refine-filters-button"
						(click)="onRefineFiltersClicked()"
					></app-data-set-action-button>
				</div>
				<div *appActionGroup style="width: 100%; display: flex; flex-direction: column">
					<app-data-set-action-button
						style="flex: 1"
						label="Download"
						i18n-label="@@inventoryReport-downloadReport"
						svgIcon="sl-download"
						data-automation-id="inventory-report-downloads-button"
						(click)="onDownloadClicked()"
					></app-data-set-action-button>
				</div>
			</div>
		</app-data-set-toolbar>

		<app-data-set-content>
			<app-data-set-table-view>
				@if (
					loadingService.isLoading(generateInventoryReportLoadingKey) ||
					loadingService.isLoading(generateInventoryReportCsvLoadingKey) ||
					!finishedLoadingInitData
				) {
					<app-data-set-loading-row />
				}
				<table
					mat-table
					[dataSource]="dataSource"
					matSortActive="statusChangedDate"
					matSortDirection="desc"
					matSort
					[hidden]="
						loadingService.isLoading(generateInventoryReportLoadingKey) ||
						loadingService.isLoading(generateInventoryReportCsvLoadingKey) ||
						!finishedLoadingInitData
					"
				>
					<tr class="mat-row" *matNoDataRow>
						<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
							No records found.
						</td>
					</tr>

					<ng-container matColumnDef="deviceSerialNumber">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@inventoryReport-serialNumber">
							Serial Number
						</th>
						<td mat-cell *matCellDef="let row">{{ row.deviceSerialNumber }}</td>
					</ng-container>

					<ng-container matColumnDef="deviceStatus">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@inventoryReport-deviceStatus">
							Device Status
						</th>
						<td mat-cell *matCellDef="let row">{{ row.deviceStatus }}</td>
					</ng-container>

					<ng-container matColumnDef="deviceStatusChangeDate">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@inventoryReport-deviceStatusChangeDate">
							Status Changed
						</th>
						<td mat-cell *matCellDef="let row">{{ row.deviceStatusChangeDate }}</td>
					</ng-container>

					@if (isCareCompany) {
						<ng-container matColumnDef="clientName">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@inventoryReport-client">Client</th>
							<td mat-cell *matCellDef="let row">{{ row?.clientFirstName ?? '' }} {{ row?.clientLastName ?? '' }}</td>
						</ng-container>

						<ng-container matColumnDef="clientIdn">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@inventoryReport-clientIdn">Client IDN</th>
							<td mat-cell *matCellDef="let row">{{ row?.clientIdn ?? '' }}</td>
						</ng-container>
					}

					<ng-container matColumnDef="locationName">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@inventoryReport-locationName">
							Property Name
						</th>
						<td mat-cell *matCellDef="let row">{{ row.locationName }}</td>
					</ng-container>

					<ng-container matColumnDef="locationInstallationName">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@inventoryReport-deviceLocation">
							Device Location
						</th>
						<td mat-cell *matCellDef="let row">{{ row.locationInstallationName }}</td>
					</ng-container>

					<ng-container matColumnDef="streetAddress">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@inventoryReport-streetAddress">
							Street Address
						</th>
						<td mat-cell *matCellDef="let row">
							{{
								row.streetAddress1 ? row.streetAddress1 + (row.streetAddress2 ? ' & ' + row.streetAddress2 : '') : ''
							}}
						</td>
					</ng-container>

					<ng-container matColumnDef="region">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@inventoryReport-townCity">Town/City</th>
						<td mat-cell *matCellDef="let row">
							{{ row.locality ? row.locality + (row.stateProvinceRegion ? ', ' + row.stateProvinceRegion : '') : '' }}
						</td>
					</ng-container>

					<ng-container matColumnDef="postalCode">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@inventoryReport-postalCode">Postal Code</th>
						<td mat-cell *matCellDef="let row">{{ row.postalCode }}</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
					<tr
						mat-row
						[ngClass]="{ 'code-visit': row.accessType === 'Code' }"
						*matRowDef="let row; columns: displayedColumns"
					></tr>
				</table>
			</app-data-set-table-view>
		</app-data-set-content>
	</app-data-set>
</app-navigation-header>
